export default "__VITE_ASSET__41632f78__"